import { ReviewCategoriesStats } from "@/mk2/apps/wiki/containers/Article/Article.reducers";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Article load

export const ARTICLE_EXPERIENCE_PHOTO_FETCH_TRIGGER = "WIKI_ARTICLE_EXPERIENCE_PHOTO_FETCH_TRIGGER"; // WIKI_ prefix aby sa nemiesalo s akciami pre Article v blogoch
export interface ArticleExperiencePhotoFetchTriggerAction {
    readonly type: typeof ARTICLE_EXPERIENCE_PHOTO_FETCH_TRIGGER;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly experienceId: number;
    readonly photoId: number;
}
export const ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST = "WIKI_ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST";
export interface ArticleExperiencePhotoFetchRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly experienceId: number;
    readonly photoId: number;
}
export interface ArticleExperiencePhotoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        article: number;
    };
}
export const ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS = "WIKI_ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS";
export interface ArticleExperiencePhotoFetchSuccessAction extends APISuccessAction<ArticleExperiencePhotoFetchNormalizedResponse> {
    readonly type: typeof ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly experienceId: number;
    readonly photoId: number;
}
export const ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE = "WIKI_ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE";
export interface ArticleExperiencePhotoFetchFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly experienceId: number;
    readonly photoId: number;
}

export const articleExperiencePhotoFetchTrigger = (
    articleSlug: string,
    categorySlug: string,
    experienceId: number,
    photoId: number,
): ArticleExperiencePhotoFetchTriggerAction => ({
    type: ARTICLE_EXPERIENCE_PHOTO_FETCH_TRIGGER,
    articleSlug,
    categorySlug,
    experienceId,
    photoId,
});
export const articleExperiencePhotoFetchApi = {
    request: (
        articleSlug: string,
        categorySlug: string,
        experienceId: number,
        photoId: number,
    ): ArticleExperiencePhotoFetchRequestAction => ({
        type: ARTICLE_EXPERIENCE_PHOTO_FETCH_REQUEST,
        articleSlug,
        categorySlug,
        experienceId,
        photoId,
    }),
    success: (
        articleSlug: string,
        categorySlug: string,
        experienceId: number,
        photoId: number,
        response: ArticleExperiencePhotoFetchNormalizedResponse,
    ): ArticleExperiencePhotoFetchSuccessAction => ({
        type: ARTICLE_EXPERIENCE_PHOTO_FETCH_SUCCESS,
        articleSlug,
        categorySlug,
        experienceId,
        photoId,
        response,
    }),
    failure: (
        articleSlug: string,
        categorySlug: string,
        experienceId: number,
        photoId: number,
        error: string,
    ): ArticleExperiencePhotoFetchFailureAction => ({
        type: ARTICLE_EXPERIENCE_PHOTO_FETCH_FAILURE,
        articleSlug,
        categorySlug,
        experienceId,
        photoId,
        error,
    }),
};
